/* SUMMARY - This line cannot be edited or removed */
export const GET_ALL_SUMMARIES = "GET_ALL_SUMMARIES"
export const GET_ALL_SUMMARIES_SUCCESS = "GET_ALL_SUMMARIES_SUCCESS"
export const GET_ALL_SUMMARIES_FAIL = "GET_ALL_SUMMARIES_FAIL"

/* SUMMARY DETAILS */
export const GET_SUMMARY_DETAILS = "GET_SUMMARY_DETAILS"
export const GET_SUMMARY_DETAILS_SUCCESS = "GET_SUMMARY_DETAILS_SUCCESS"
export const GET_SUMMARY_DETAILS_FAIL = "GET_SUMMARY_DETAILS_FAIL"

/* CREATE SUMMARY */
export const CREATE_SUMMARY = "CREATE_SUMMARY"
export const CREATE_SUMMARY_SUCCESS = "CREATE_SUMMARY_SUCCESS"
export const CREATE_SUMMARY_FAIL = "CREATE_SUMMARY_FAIL"
